/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: actions.ts
 * Class: actions.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { ActionTree } from 'vuex';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { ContractLocation, ContractLocationsState } from './types';
import { RootState } from '../types';
import { ApiEndpointEnum, getApiRequestConfig } from '../../config/network';

export const actions: ActionTree<ContractLocationsState, RootState> = {
  fetchContractLocations(
    { commit },
    payload: { productId: number; gameId: number },
  ): Promise<Array<ContractLocation>> {
    commit('contractLocationsLoading');

    return new Promise<Array<ContractLocation>>((resolve, reject) => {
      this.state.$http(`contractLocations/${payload.productId}/${payload.gameId}`, getApiRequestConfig(ApiEndpointEnum.Payment))
        .then((response: AxiosResponse<Array<ContractLocation>>) => {
          const contractLocations: Array<ContractLocation> = response && response.data;

          commit('contractLocationsLoaded', contractLocations);
          resolve(contractLocations);
        }, (error) => {
          commit('contractLocationsError');
          reject(error);
        });
    });
  },
};
